import { Navigate, useLocation } from 'react-router-dom';

import { PageProps } from '@/pages/PageProps';

const LEGACY_MANAGE_REFILLS_PREFIX = '/manage-refills';
const PREPAID_REFILLS_PREFIX = '/prepaid-refills';

export function getLegacyManageRefillsRedirectTarget(pathname: string, search = ''): string {
  const targetPath = pathname.startsWith(LEGACY_MANAGE_REFILLS_PREFIX)
    ? `${PREPAID_REFILLS_PREFIX}${pathname.slice(LEGACY_MANAGE_REFILLS_PREFIX.length)}`
    : PREPAID_REFILLS_PREFIX;

  return `${targetPath}${search}`;
}

function LegacyManageRefillsRedirect(_props: PageProps) {
  const location = useLocation();

  return (
    <Navigate
      to={getLegacyManageRefillsRedirectTarget(location.pathname, location.search)}
      replace
    />
  );
}

export default LegacyManageRefillsRedirect;
